module.exports = __webpack_public_path__ + "img/img_rendering-patios.e319c693.jpg";